module.exports = __webpack_public_path__ + "static/media/lizzie-hessek.cd117e2c.md";